import { config } from '@src/config';
import axios from '@src/core/http';

import { APIcallerv2 } from '@services/APIcaller';

const baseApiUrl = `${config.baseApiUrl}/v1`;

export const getClients = async () => {
  const { data } = await axios.get(`${baseApiUrl}/backoffice/clients`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('loopbackAccessToken'),
    },
  });

  return data;
};

export const getRecipes = async (storeId) => APIcallerv2.apiGet('/debugger/recipes', { storeId });

export const getStores = async () => APIcallerv2.apiGet('/stores');

export const getAnalysisByIngredient = async (clientId, storeIds, startDate, endDate, entityId) => {
  const { data } = await axios.post(
    `${baseApiUrl}/backoffice/clients/${clientId}/debugger/recipes/analysis-by-ingredient`,
    {
      startDate,
      endDate,
      storeIds,
      entityId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('loopbackAccessToken'),
      },
    },
  );

  return data;
};
